import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import User from '../views/sys/User.vue'
import Role from '../views/sys/Role.vue'
import Menu from '../views/sys/Menu.vue'
import Unit from '../views/sys/Unit.vue'
import Dept from '../views/base/Dept.vue'
import Identity from '../views/base/Identity.vue'
import Person from '../views/base/Person.vue'
import PersonImport from '../views/base/PersonImport.vue'
import FingerList from '../views/base/FingerList.vue'
import Location from '../views/base/Location.vue'
import Gateway from '../views/iot/Gateway.vue'
import Machine from '../views/iot/Machine.vue'
import MachineTask from '../views/iot/MachineTask.vue'
import WhiteList from '../views/pin/WhiteList.vue'
import Record from '../views/pin/Record.vue'
import GroupLocation from '../views/pin/GroupLocation.vue'
import GroupPerson from '../views/pin/GroupPerson.vue'
import LocationMachine from '../views/iot/LocationMachine.vue'

import axios from "../axios";
import store from "../store"
import el from "element-ui/src/locale/lang/el";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		children: [
			{
				path: '/index',
				name: 'Index',
				meta: {
					title: "首页"
				},
				component: Index
			},
			{
				path: '/userCenter',
				name: 'UserCenter',
				meta: {
					title: "个人中心"
				},
				component: () => import('@/views/UserCenter.vue')
			},
		]
	},

	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login.vue')
	}
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  // console.log(location)
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
	// mode: 'history',
	// base: process.env.BASE_URL,
	base: '/platform/',
	routes
})

router.beforeEach((to, from, next) => {
	let hasRoute = store.state.menus.hasRoutes
	// console.log(store.state.menus);
	// console.log(store.state.menus.hasRoutes);
	let token = localStorage.getItem("token")
	if (to.path == '/login') {
		next()
	} else if (!token) {
		next({path: '/login'})
	} else if(token && !hasRoute) {
		axios.get("/sys/menu/nav", {
			headers: {
				Authorization: localStorage.getItem("token")
			}
		}).then(res => {
			// console.log(res.data.data)
			// 拿到menuList
			store.commit("setMenuList", res.data.data.nav)
			// 拿到用户权限
			store.commit("setPermList", res.data.data.authoritys)

			// 确保 hasRoutes 属性被正确设置 
			store.commit("changeRouteStatus", true); 
			// console.log(store.state.menus.menuList)
			console.log(res.data.data.nav)
			// 动态绑定路由
			let newRoutes = router.options.routes
			res.data.data.nav.forEach(menu => {
				if (menu.children) {
					menu.children.forEach(e => {
						// 转成路由
						let route = menuToRoute(e)
						// 吧路由添加到路由管理中
						if (route) {
							newRoutes[0].children.push(route)
						}
					})
				}
			})
			router.addRoutes(newRoutes)
			// hasRoute = true
			// store.commit("changeRouteStatus", hasRoute)
		})
	}
	next()
})


// 导航转成路由
const menuToRoute = (menu) => {

	if (!menu.component) {
		return null
	}

	let route = {
		name: menu.name,
		path: menu.path,
		meta: {
			icon: menu.icon,
			title: menu.title
		}
	}
	route.component = () => import('@/views/' + menu.component +'.vue')

	return route
}

export default router 